export default "__VITE_ASSET__BWzOlf2j__"